<template>
  <aside
    class="flex lg:relative lg:bg-transparent lg:w-aside flex-col p-3 lg:p-6 gap-3 lg:gap-5 z-10 lg:mt-20 sm:overflow-y-auto overflow-hidden scrollbar scrollbar-thumb-gray-1 scrollbar-track-transparent scrollbar-thin sm:scrollbar-none sm:h-auto h-full"
    :class="{
      'flex flex-col bg-block-2 z-1 w-full lg:pt-0 md:pt-8 pt-24':
        openMobileSidebar,
    }"
  >
    <Wallet v-if="isConnected" />
    <SidebarActions :is-header="false" />
    <PoolAvailable />
    <Rewards />
    <HlpSwap />
  </aside>
</template>

<script>
import { mapGetters } from "vuex";
import Wallet from "../components/global/Wallet.vue";
import PoolAvailable from "../components/global/PoolAvailable.vue";
import Rewards from "../components/global/Rewards.vue";
import SidebarActions from "../components/global/SidebarActions.vue";
import HlpSwap from "../components/hlp/Swap.vue";
export default {
  name: "Sidebar",
  components: {
    Wallet,
    PoolAvailable,
    Rewards,
    SidebarActions,
    HlpSwap,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["openMobileSidebar", "isConnected"]),
  },
};
</script>
